import React from 'react';

import { InfoError } from './componentes/ModalError';
import { DescriptorDeUsuario } from './descriptor';

// tslint:disable:prefer-method-signature
interface Ctx {
    readonly usuarioActual: DescriptorDeUsuario;
    readonly mostrarModalError: (this: void, error: string | InfoError | Error) => void;
}

export const Contexto = React.createContext<Ctx>(undefined as never);



// WEBPACK FOOTER //
// ./src/contexto.tsx